import { createCountLessonSilentMediaURL } from './count_lesson_silent_media';
// 選択画面を開くタップで準備したvideo要素を、最初に選択されているコーチへ渡す。
export class CountLessonCoachVideoPlayback {
    constructor() {
        Object.defineProperty(this, "video", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: document.createElement('video')
        });
        Object.defineProperty(this, "preparationURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    static prepareFromUserGesture() {
        CountLessonCoachVideoPlayback.discardPrepared();
        const playback = new CountLessonCoachVideoPlayback();
        CountLessonCoachVideoPlayback.prepared = playback;
        playback.preparationURL = createCountLessonSilentMediaURL();
        playback.video.src = playback.preparationURL;
        playback.video.muted = true;
        playback.video.defaultMuted = true;
        playback.video.playsInline = true;
        CountLessonCoachVideoPlayback.playFromUserGesture(playback.video);
    }
    static acquire() {
        const playback = CountLessonCoachVideoPlayback.prepared || new CountLessonCoachVideoPlayback();
        CountLessonCoachVideoPlayback.prepared = null;
        return playback;
    }
    static playFromUserGesture(video) {
        void video.play().catch((error) => {
            // 選択切替で中断した要求とブラウザによる拒否は、表示側の再生処理で扱う。
            if (error.name === 'AbortError' || error.name === 'NotAllowedError')
                return;
            throw error;
        });
    }
    static discardPrepared() {
        var _a;
        (_a = CountLessonCoachVideoPlayback.prepared) === null || _a === void 0 ? void 0 : _a.dispose();
        CountLessonCoachVideoPlayback.prepared = null;
    }
    dispose() {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
        if (this.preparationURL)
            URL.revokeObjectURL(this.preparationURL);
        this.preparationURL = null;
    }
}
Object.defineProperty(CountLessonCoachVideoPlayback, "prepared", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: null
});
